<template>
  <div class="hidden md:flex w-full h-full">
    <div v-if="newsPosts.length === 1">
      <div class="h-full max-h-full">
        <NewsPostGridTile
            :newsPost="newsPosts[0]"
            :extraClasses="'rounded-xl'"
            :titleTextExtraClasses="'text-md'"
        />
      </div>
    </div>
    <div v-else-if="newsPosts.length === 2">
      <div class="flex flex-row w-full h-full max-h-full">
        <div class="flex flex-col h-full w-1/2 pr-1">
          <NewsPostGridTile
              :newsPost="newsPosts[0]"
              :extraClasses="'rounded-l-xl'"
              :titleTextExtraClasses="'text-md'"
          />
        </div>
        <div class="flex flex-col h-full max-h-full w-1/2 pl-1">
          <NewsPostGridTile
              :newsPost="newsPosts[1]"
              :extraClasses="'rounded-r-xl'"
              :titleTextExtraClasses="'text-md'"
          />
        </div>
      </div>
    </div>
    <div v-else-if="newsPosts.length === 3">
      <div class="flex flex-row w-full h-full max-h-full">
        <div class="flex flex-col h-full max-h-full w-1/2 pr-1">
          <NewsPostGridTile
              :newsPost="newsPosts[0]"
              :extraClasses="'rounded-l-xl'"
              :titleTextExtraClasses="'text-md'"
          />
        </div>
        <div class="flex flex-col h-full max-h-full w-1/2 pl-1">
          <div class="h-1/2 pb-1">
            <NewsPostGridTile
                :newsPost="newsPosts[1]"
                :extraClasses="'rounded-tr-xl'"
                :titleTextExtraClasses="'text-md'"
            />
          </div>
          <div class="h-1/2 pt-1">
            <NewsPostGridTile
                :newsPost="newsPosts[2]"
                :extraClasses="'rounded-br-xl'"
                :titleTextExtraClasses="'text-md'"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="newsPosts.length === 4">
      <div class="flex flex-row w-full h-full max-h-full">
        <div class="flex flex-col h-full max-h-full w-1/2 pr-0.5">
          <NewsPostGridTile
              :newsPost="newsPosts[0]"
              :extraClasses="'rounded-l-xl'"
              :titleTextExtraClasses="'text-lg'"
              :publishDateTextExtraClasses="'text-sm'"
          />
        </div>
        <div class="flex flex-col h-full max-h-full w-1/2 pl-0.5">
          <div class="w-full h-1/2 pb-0.5">
            <NewsPostGridTile
                :newsPost="newsPosts[1]"
                :extraClasses="'rounded-tr-xl '"
                :titleTextExtraClasses="'text-lg'"
                :publishDateTextExtraClasses="'text-sm'"
            />
          </div>
          <div class="flex flex-row w-full h-1/2 pt-0.5">
            <NewsPostGridTile
                :newsPost="newsPosts[2]"
                :extraClasses="'pr-0.5'"
                :titleTextExtraClasses="'text-lg'"
                :publishDateTextExtraClasses="'text-sm'"
            />
            <NewsPostGridTile
                :newsPost="newsPosts[3]"
                :extraClasses="'rounded-br-xl pl-0.5'"
                :titleTextExtraClasses="'text-lg'"
                :publishDateTextExtraClasses="'text-sm'"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- In Case Of 5 Images -->
    <div v-else-if="newsPosts.length === 5 || newsPosts.length > 5">
      <div class="flex flex-row w-full h-full max-h-full">
        <div class="flex flex-col h-full max-h-full w-1/2 pr-0.5">
          <NewsPostGridTile
              :newsPost="newsPosts[0]"
              :extraClasses="'rounded-l-xl'"
              :titleTextExtraClasses="'text-lg'"
              :publishDateTextExtraClasses="'text-sm'"
          />
        </div>
        <div class="flex flex-col h-full max-h-full w-1/2 pl-0.5">
          <div class="flex flex-row w-full h-1/2 pb-0.5">
            <NewsPostGridTile
                :newsPost="newsPosts[1]"
                :extraClasses="'pr-0.5'"
                :titleTextExtraClasses="'text-lg'"
                :publishDateTextExtraClasses="'text-sm'"
            />
            <NewsPostGridTile
                :newsPost="newsPosts[2]"
                :extraClasses="'rounded-tr-xl '"
                :titleTextExtraClasses="'text-lg'"
                :publishDateTextExtraClasses="'text-sm'"
            />
          </div>
          <div class="flex flex-row w-full h-1/2 pt-0.5">
            <NewsPostGridTile
                :newsPost="newsPosts[3]"
                :extraClasses="'pr-0.5'"
                :titleTextExtraClasses="'text-lg'"
                :publishDateTextExtraClasses="'text-sm'"
            />
            <NewsPostGridTile
                :newsPost="newsPosts[4]"
                :extraClasses="'rounded-br-xl pl-0.5'"
                :titleTextExtraClasses="'text-lg'"
                :publishDateTextExtraClasses="'text-sm'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex md:hidden ">
    <div
        class="swiper newsPostGridCarousel w-full h-56"
    >
      <div class="swiper-wrapper">
        <div
            v-for="newsPost in newsPosts"
            :key="newsPost.slug"
            class="swiper-slide text-black flex flex-row items-center w-full"
        >
          <NewsPostGridTile
              :newsPost="newsPost"
              :extraClasses="''"
              :titleTextExtraClasses="'text-lg'"
              :publishDateTextExtraClasses="'text-sm'"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script
    setup
    lang="ts"
>
import type {NewsHomeNewsPostListItem, NewsPost} from "~/types";
import {Autoplay} from "swiper/modules";

const props = withDefaults(defineProps<{
  newsPosts: NewsHomeNewsPostListItem[]
}>(), {})


const swiper = ref(null);
onMounted(() => {
  swiper.value = new useNuxtApp().$swiper('.newsTickerBarCarousel', {
    modules: [Autoplay],
    direction: 'vertical',
    loop: true,
    autoplay: {
      delay: 4000,
    },
    speed: 500,
    slidesPerView: 1,
    centeredSlides: true,
    allowTouchMove: false,
    observer: true,
    effect: 'slide'
  })
})
</script>
<style></style>
